export const GET_STOP_CAUSES_REQUEST = 'GET_STOP_CAUSES_REQUEST';
export const GET_STOP_CAUSES_SUCCESS = 'GET_STOP_CAUSES_SUCCESS';
export const GET_STOP_CAUSES_ERROR = 'GET_STOP_CAUSES_ERROR';

export const GET_STOP_SPECIFIC_CAUSES_REQUEST =
  'GET_STOP_SPECIFIC_CAUSES_REQUEST';
export const GET_STOP_SPECIFIC_CAUSES_SUCCESS =
  'GET_STOP_SPECIFIC_CAUSES_SUCCESS';
export const GET_STOP_SPECIFIC_CAUSES_ERROR = 'GET_STOP_SPECIFIC_CAUSES_ERROR';

export const SPLIT_STOP_REQUEST = 'SPLIT_STOP_REQUEST';
export const SPLIT_STOP_SUCCESS = 'SPLIT_STOP_SUCCESS';
export const SPLIT_STOP_ERROR = 'SPLIT_STOP_ERROR';

export const CREATE_GENERAL_CAUSE_POST = 'CREATE_GENERAL_CAUSE_POST';
export const CREATE_GENERAL_CAUSE_SUCCESS = 'CREATE_GENERAL_CAUSE_SUCCESS';
export const CREATE_GENERAL_CAUSE_ERROR = 'CREATE_GENERAL_CAUSE_ERROR';

export const CREATE_SPECIFIC_CAUSE_POST = 'CREATE_SPECIFIC_CAUSE_POST';
export const CREATE_SPECIFIC_CAUSE_SUCCESS = 'CREATE_SPECIFIC_CAUSE_SUCCESS';
export const CREATE_SPECIFIC_CAUSE_ERROR = 'CREATE_SPECIFIC_CAUSE_ERROR';

export const CREATE_BULK_GENERAL_CAUSES_POST =
  'CREATE_BULK_GENERAL_CAUSES_POST';
export const CREATE_BULK_GENERAL_CAUSES_SUCCESS =
  'CREATE_BULK_GENERAL_CAUSES_SUCCESS';
export const CREATE_BULK_GENERAL_CAUSES_ERROR =
  'CREATE_BULK_GENERAL_CAUSES_ERROR';

export const CREATE_BULK_SPECIFIC_CAUSES_POST =
  'CREATE_BULK_SPECIFIC_CAUSES_POST';
export const CREATE_BULK_SPECIFIC_CAUSES_SUCCESS =
  'CREATE_BULK_SPECIFIC_CAUSES_SUCCESS';
export const CREATE_BULK_SPECIFIC_CAUSES_ERROR =
  'CREATE_BULK_SPECIFIC_CAUSES_ERROR';

export const CREATE_COMPONENT_POST = 'CREATE_COMPONENT_POST';
export const CREATE_COMPONENT_SUCCESS = 'CREATE_COMPONENT_SUCCESS';
export const CREATE_COMPONENT_ERROR = 'CREATE_COMPONENT_ERROR';

export const DELETE_GENERAL_CAUSE_POST = 'DELETE_GENERAL_CAUSE_POST';
export const DELETE_GENERAL_CAUSE_SUCCESS = 'DELETE_GENERAL_CAUSE_SUCCESS';
export const DELETE_GENERAL_CAUSE_ERROR = 'DELETE_GENERAL_CAUSE_ERROR';

export const DELETE_SPECIFIC_CAUSE_POST = 'DELETE_SPECIFIC_CAUSE_POST';
export const DELETE_SPECIFIC_CAUSE_SUCCESS = 'DELETE_SPECIFIC_CAUSE_SUCCESS';
export const DELETE_SPECIFIC_CAUSE_ERROR = 'DELETE_SPECIFIC_CAUSE_ERROR';

export const DELETE_COMPONENT_POST = 'DELETE_COMPONENT_POST';
export const DELETE_COMPONENT_SUCCESS = 'DELETE_COMPONENT_SUCCESS';
export const DELETE_COMPONENT_ERROR = 'DELETE_COMPONENT_ERROR';

export const GET_COMPONENT_LIST_REQUEST = 'GET_COMPONENT_LIST_REQUEST';
export const GET_COMPONENT_LIST_SUCCESS = 'GET_COMPONENT_LIST_SUCCESS';
export const GET_COMPONENT_LIST_ERROR = 'GET_COMPONENT_LIST_ERROR';

export const UPDATE_COMPONENT_LIST_REQUEST = 'UPDATE_COMPONENT_LIST_REQUEST';
export const UPDATE_COMPONENT_LIST_SUCCESS = 'UPDATE_COMPONENT_LIST_SUCCESS';
export const UPDATE_COMPONENT_LIST_ERROR = 'UPDATE_COMPONENT_LIST_ERROR';

export const DELETE_COMPONENT_LIST_POST = 'DELETE_COMPONENT_LIST_POST';
export const DELETE_COMPONENT_LIST_SUCCESS = 'DELETE_COMPONENT_LIST_SUCCESS';
export const DELETE_COMPONENT_LIST_ERROR = 'DELETE_COMPONENT_LIST_ERROR';

export const ADD_COMPONENT_GROUP = 'ADD_COMPONENT_GROUP';
export const ADD_TREE_LOSS = 'ADD_TREE_LOSS';
export const UPDATE_COMPONENT_GROUP = 'UPDATE_COMPONENT_GROUP';
export const DELETE_COMPONENT_GROUP = 'DELETE_COMPONENT_GROUP';

export const GET_TREE_LOSSES_REQUEST = 'GET_TREE_LOSSES_REQUEST';
export const GET_TREE_LOSSES_SUCCESS = 'GET_TREE_LOSSES_SUCCESS';
export const GET_TREE_LOSSES_ERROR = 'GET_TREE_LOSSES_ERROR';

export const UPDATE_TREE_LOSS_REQUEST = 'UPDATE_TREE_LOSS_REQUEST';
export const UPDATE_TREE_LOSS_SUCCESS = 'UPDATE_TREE_LOSS_SUCCESS';
export const UPDATE_TREE_LOSS_ERROR = 'UPDATE_TREE_LOSS_ERROR';

export const CREATE_TREE_LOSS_REQUEST = 'CREATE_TREE_LOSS_REQUEST';
export const CREATE_TREE_LOSS_SUCCESS = 'CREATE_TREE_LOSS_SUCCESS';
export const CREATE_TREE_LOSS_ERROR = 'CREATE_TREE_LOSS_ERROR';

export const DUPLICATE_TREE_LOSS_REQUEST = 'DUPLICATE_TREE_LOSS_REQUEST';
export const DUPLICATE_TREE_LOSS_SUCCESS = 'DUPLICATE_TREE_LOSS_SUCCESS';
export const DUPLICATE_TREE_LOSS_ERROR = 'DUPLICATE_TREE_LOSS_ERROR';

export const DELETE_TREE_LOSS_REQUEST = 'DELETE_TREE_LOSS_REQUEST';
export const DELETE_TREE_LOSS_SUCCESS = 'DELETE_TREE_LOSS_SUCCESS';
export const DELETE_TREE_LOSS_ERROR = 'DELETE_TREE_LOSS_ERROR';

export const UPDATE_TREE_LOSS_MACHINE_REQUEST =
  'UPDATE_TREE_LOSS_MACHINE_REQUEST';
export const UPDATE_TREE_LOSS_MACHINE_SUCCESS =
  'UPDATE_TREE_LOSS_MACHINE_SUCCESS';
export const UPDATE_TREE_LOSS_MACHINE_ERROR = 'UPDATE_TREE_LOSS_MACHINE_ERROR';

export const DELETE_TREE_LOSS_MACHINE_REQUEST =
  'DELETE_TREE_LOSS_MACHINE_REQUEST';
export const DELETE_TREE_LOSS_MACHINE_SUCCESS =
  'DELETE_TREE_LOSS_MACHINE_SUCCESS';
export const DELETE_TREE_LOSS_MACHINE_ERROR = 'DELETE_TREE_LOSS_MACHINE_ERROR';

export const GET_MACHINE_EQUIPMENTS_REQUEST = 'GET_MACHINE_EQUIPMENTS_REQUEST';
export const GET_MACHINE_EQUIPMENTS_SUCCESS = 'GET_MACHINE_EQUIPMENTS_SUCCESS';
export const GET_MACHINE_EQUIPMENTS_ERROR = 'GET_MACHINE_EQUIPMENTS_ERROR';

export const UPDATE_MACHINE_EQUIPMENTS_REQUEST =
  'UPDATE_MACHINE_EQUIPMENTS_REQUEST';
export const UPDATE_MACHINE_EQUIPMENTS_SUCCESS =
  'UPDATE_MACHINE_EQUIPMENTS_SUCCESS';
export const UPDATE_MACHINE_EQUIPMENTS_ERROR =
  'UPDATE_MACHINE_EQUIPMENTS_ERROR';

export const CREATE_BULK_EQUIPMENTS_POST = 'CREATE_BULK_EQUIPMENTS_POST';
export const CREATE_BULK_EQUIPMENTS_SUCCESS = 'CREATE_BULK_EQUIPMENTS_SUCCESS';
export const CREATE_BULK_EQUIPMENTS_ERROR = 'CREATE_BULK_EQUIPMENTS_ERROR';

export const UPDATE_FAILED_STOP_CAUSES = 'UPDATE_FAILED_STOP_CAUSES';

export const CREATE_STOP_AUTOMATION_REQUEST = 'CREATE_STOP_AUTOMATION_REQUEST';
export const CREATE_STOP_AUTOMATION_SUCCESS = 'CREATE_STOP_AUTOMATION_SUCCESS';
export const CREATE_STOP_AUTOMATION_ERROR = 'CREATE_STOP_AUTOMATION_ERROR';

export const GET_STOP_AUTOMATIONS_REQUEST = 'GET_STOP_AUTOMATIONS_REQUEST';
export const GET_STOP_AUTOMATIONS_SUCCESS = 'GET_STOP_AUTOMATIONS_SUCCESS';
export const GET_STOP_AUTOMATIONS_ERROR = 'GET_STOP_AUTOMATIONS_ERROR';

export const UPDATE_STOP_AUTOMATION_REQUEST = 'UPDATE_STOP_AUTOMATION_REQUEST';
export const UPDATE_STOP_AUTOMATION_SUCCESS = 'UPDATE_STOP_AUTOMATION_SUCCESS';
export const UPDATE_STOP_AUTOMATION_ERROR = 'UPDATE_STOP_AUTOMATION_ERROR';

export const DELETE_STOP_AUTOMATION_REQUEST = 'DELETE_STOP_AUTOMATION_REQUEST';
export const DELETE_STOP_AUTOMATION_SUCCESS = 'DELETE_STOP_AUTOMATION_SUCCESS';
export const DELETE_STOP_AUTOMATION_ERROR = 'DELETE_STOP_AUTOMATION_ERROR';

export const CLEAR_SPLIT_STOPS = 'CLEAR_SPLIT_STOPS';

export const SET_PROGRAMMED_SPECIFIC_CAUSE = 'SET_PROGRAMMED_SPECIFIC_CAUSE';
export const SET_PROGRAMMED_SPECIFIC_CAUSE_SUCCESS =
  'SET_PROGRAMMED_SPECIFIC_CAUSE_SUCCESS';
export const SET_PROGRAMMED_SPECIFIC_CAUSE_ERROR =
  'SET_PROGRAMMED_SPECIFIC_CAUSE_ERROR';

export const SET_NOT_PROGRAMMED_SPECIFIC_CAUSE =
  'SET_NOT_PROGRAMMED_SPECIFIC_CAUSE';
export const SET_NOT_PROGRAMMED_SPECIFIC_CAUSE_SUCCESS =
  'SET_NOT_PROGRAMMED_SPECIFIC_CAUSE_SUCCESS';
export const SET_NOT_PROGRAMMED_SPECIFIC_CAUSE_ERROR =
  'SET_NOT_PROGRAMMED_SPECIFIC_CAUSE_ERROR';
